<template>
  <span v-if="guide" class="contextual-video-guide">
    <button type="button" class="btn btn-outline-primary" :aria-label="'Guide vidéo : ' + guide.title" @click="open">
      <i class="fa fa-play-circle" aria-hidden="true"></i> Guide vidéo
    </button>
    <b-modal v-model="show" :title="guide.title" modal-class="guide-player-modal" @hide="stop">
      <div class="guide-toolbar">
      <p class="guide-description">Démonstration avec des données fictives. Ce guide ne réalise aucune opération sur votre dossier.</p>
      <label v-if="guides.length > 1" class="guide-choice">Choisir un guide
        <select v-model="selectedId" class="form-control" @change="switchGuide">
          <option v-for="item in guides" :key="item.id" :value="item.id">{{ item.title }}</option>
        </select>
      </label>
      </div>
      <div v-if="show && !failed" class="guide-video-stage">
      <video :key="guide.id" ref="video" class="guide-video" controls playsinline preload="none" :aria-label="guide.title" @error="failed=true">
        <source :src="asset(guide.video)" type="video/mp4" @error="failed=true">
        <!-- The MP4 already includes its caption panel. Do not overlay a second track. -->
        Votre navigateur ne peut pas lire cette vidéo. Consultez la transcription ci-dessous.
      </video>
      </div>
      <p v-if="failed" class="alert alert-warning" role="alert">La vidéo est indisponible. Vous pouvez consulter la transcription ci-dessous.</p>
      <details :open="failed" class="guide-transcript">
        <summary>Lire le résumé des étapes</summary>
        <ol><li v-for="(step,index) in guide.transcript" :key="index">{{ step }}</li></ol>
      </details>
      <template v-slot:modal-footer><button type="button" class="btn btn-outline-secondary" @click="close">Fermer</button></template>
    </b-modal>
  </span>
</template>
<script>
import { listVideoGuides, guideAssetUrl } from '@/utils/video-guides'
export default {
  name: 'ContextualVideoGuide',
  props: { page: {type:String,required:true}, contextKey: {type:[String,Number],default:''} },
  data: () => ({show:false,failed:false,selectedId:''}),
  computed: {
    role() { return (this.$store.getters.activeRole || {}).nom || '' },
    userId() { const auth=this.$store.getters.authInfo || {};return auth.id || (auth.user || {}).id || '' },
    guides() { return listVideoGuides(this.page,this.role) },
    guide() { return this.guides.find(item => item.id === this.selectedId) || this.guides[0] || null }
  },
  watch: { role() { this.close() }, userId() { this.close() }, page() { this.close() }, contextKey() { this.close() } },
  beforeDestroy() { this.stop() },
  deactivated() { this.close() },
  methods: {
    asset(path) { return guideAssetUrl(path,process.env.BASE_URL || '/') },
    open() { if(!this.guide) return;this.selectedId=this.guide.id;this.failed=false;this.show=true },
    switchGuide() { this.stop();this.failed=false },
    stop() { const video=this.$refs.video;if(video) video.pause() },
    close() { this.stop();this.show=false;this.selectedId='' }
  }
}
</script>
<style>
/* Bootstrap-Vue portals the dialog to body: scope by its explicit modal class. */
.guide-player-modal .modal-dialog{width:calc(100% - 16px);max-width:none;margin:8px auto}
.guide-player-modal .modal-content{height:calc(100vh - 16px);height:calc(100dvh - 16px);max-height:none}
.guide-player-modal .modal-header{flex-shrink:0;padding:10px 16px;align-items:center}
.guide-player-modal .modal-title{font-size:20px;line-height:1.25;color:var(--ui-text,#172033)}
.guide-player-modal .modal-content .modal-body{display:flex;flex:1 1 auto;flex-direction:column;gap:10px;min-height:0;max-height:none;padding:10px 16px;overflow:auto}
.guide-player-modal .modal-footer{flex-shrink:0;padding:8px 16px}
.guide-player-modal .guide-toolbar{flex-shrink:0;display:flex;align-items:center;gap:12px;flex-wrap:wrap}
.guide-player-modal .guide-description{flex:1 1 260px;margin:0;font-size:13px;line-height:1.4;color:var(--ui-text-secondary,#273449)}
.guide-player-modal .guide-choice{display:flex;flex:1 1 440px;align-items:center;gap:10px;margin:0;color:var(--ui-text-secondary,#273449);font-size:14px;white-space:nowrap}
.guide-player-modal .guide-choice select{flex:1;min-width:0;width:0;height:44px;font-size:14px;border-radius:14px}
.guide-player-modal .guide-video-stage{flex:1 1 0;min-height:0;display:flex;background:#172033;border-radius:14px;overflow:hidden}
.guide-player-modal .guide-video{display:block;width:100%;height:100%;min-height:0;object-fit:contain}
.guide-player-modal .guide-transcript{flex-shrink:0;margin:0;color:var(--ui-text-secondary,#273449)}
.guide-player-modal .guide-transcript summary{cursor:pointer;color:var(--ui-accent,#2457c5);font-weight:600;font-size:14px;padding:4px 0}
.guide-player-modal .guide-transcript ol{max-height:22vh;overflow:auto;margin:8px 0;padding-right:12px}
.guide-player-modal .guide-transcript li{margin:8px 0;line-height:1.5}
.guide-player-modal .guide-transcript summary:focus-visible,.guide-player-modal .guide-video:focus-visible{outline:2px solid var(--ui-accent,#2457c5);outline-offset:3px}
@media(max-width:575px){.guide-player-modal .modal-header,.guide-player-modal .modal-body,.guide-player-modal .modal-footer{padding-left:10px;padding-right:10px}.guide-player-modal .modal-title{font-size:17px}.guide-player-modal .guide-choice{flex-basis:100%;flex-direction:column;align-items:stretch;gap:4px}.guide-player-modal .guide-choice select{width:100%;flex:none}}
@media(max-height:420px){.guide-player-modal .guide-video-stage{flex:none;height:180px}}
@media print{.contextual-video-guide{display:none}}
</style>
